import React, { useEffect, useState, useRef } from 'react';
import DevotionalWeeklyCard from './devotionalWeeklyCard';


function ArticleSkeleton() {
  return (
    <div className="dna-article-card dna-skeleton-card" aria-hidden="true">
      <div className="dna-card-thumb dna-skeleton-box" />
      <div className="dna-card-body">
        <div className="dna-skeleton-line dna-skeleton-line--title" />
        <div className="dna-skeleton-line dna-skeleton-line--desc" />
        <div className="dna-skeleton-line dna-skeleton-line--desc dna-skeleton-line--short" />
      </div>
    </div>
  );
}




const WeeklyAudios = ({ cat_id, ssrData = [] ,ssrCatId }) => {
  const itemsPerPage = 6;

  
  const initialData = Array.isArray(ssrData) && ssrData.length > 0
    ? ssrData.map(item => ({
        img: item.aud_img,
        title: item.aud_title,
        url: item.aud_url,
      }))
    : [];

  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const lastFetchedCatId = useRef(cat_id);

  useEffect(() => {
    const isSameCatId = lastFetchedCatId.current === cat_id === ssrCatId;
    const isSSRValid = Array.isArray(ssrData) && ssrData.length > 0;

    if (isSSRValid && isSameCatId) {
      setLoading(false);
      lastFetchedCatId.current = cat_id
      return;
    }
    setData(null)
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(
          `https://www.teluguone.com/devotional_api/devotionalWeeklyAudioStotrasJson?cat_id=${cat_id}&start=0&limit=200`
        );

        if (!res.ok) throw new Error("Response was not OK");

        const jsonData = await res.json();
        const formatted = jsonData.devotional_weekly_content.map(item => ({
          img: item.aud_img,
          title: item.aud_title,
          url: item.aud_url,
        }));

        setData(formatted);
        setCurrentPage(1);
        lastFetchedCatId.current = cat_id;
      } catch (e) {
        setError(e.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [cat_id]);

  const totalPages = Math.ceil(data?.length / itemsPerPage);
  const paginatedData = data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => setCurrentPage(page);

  // ---------- Loading State ----------
  if (loading) {
    return (
      <div className="row">
        {[...Array(4)].map((_, index) => (
          <div className="col-12 col-sm-6" key={index}>
             <ArticleSkeleton />
          </div>
        ))}
      </div>
    );
  }

  
  if (error) {
    return (
      <div className="row">
        <div className="col-12">
          <div className="json-loading-error-div text-center">
            <img src="/devotional/assets/images/json_error.png" alt="json_error" />
            <p className="text-danger">{error}</p>
          </div>
        </div>
      </div>
    );
  }

 
  return (
    <div className="row g-0" style={{border:"1px solid #e8ddd0",backgroundColor:"#e8ddd0"}} >
      <div className="col-12 devotional-videos-header">Audios</div>

      {Array.isArray(paginatedData) && paginatedData.map((item, index) => (
        <DevotionalWeeklyCard key={item.url || index} item={item} index={index} />
      ))}

      {totalPages > 1 && (
        <div className="col-12 d-flex justify-content-center flex-wrap mt-3 gap-1 mb-2">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => handlePageChange(i + 1)}
              className={`btn ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'} mx-1`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default WeeklyAudios;
